import { GenericObject } from "utility/misc";

export default function redirectToJiraConnectPage(
  orgStore: GenericObject,
  navigate: Function
): void {
  navigate("/environment/destinations/jira/connect");
}
